const React = require('react');

import {ThirdLayerNavigation} from "../../../../../helpers/Menu";
import {MERCHANT_MANAGEMENT_SUBMENU} from "../../../../../../constants/links";

const WithdrawalAccount = require('./Accounts');
const SettlementsAndRefunds = require('./SettlementsAndRefunds').default;
const BuyerAMLPreference = require('./BuyerAMLPreference');
const Promotions = require('./Promotions');

const VIEWS = {
  withdrawalAccounts: WithdrawalAccount,
  settlementsAndRefunds: SettlementsAndRefunds,
  buyerAMLPreference: BuyerAMLPreference,
  promotions: Promotions,
};


module.exports = () => {
  return (
    <ThirdLayerNavigation
      links={MERCHANT_MANAGEMENT_SUBMENU}
      views={VIEWS}
    />
  );
};
